import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Input, Space, Spin, message } from "antd";
import { createSprText, fetchSprText, saveSprText } from "./spr-text-api";
import { normalizeSprText } from "./spr-text-utils";

const LABEL_WIDTH = 110;

const formItemLayout = {
  labelCol: { flex: `0 0 ${LABEL_WIDTH}px` },
  wrapperCol: { flex: "1 1 auto" },
  labelAlign: "right"
};

/**
 * Карточка шаблона: Код + Содержание (NAME), как Delphi TFrmESprText.
 */
const SprTextMain = ({
  vid,
  idText,
  idUpper,
  isNew,
  hideKod,
  open,
  canEdit,
  onSaved,
  onCancel
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");

    if (isNew) {
      form.resetFields();
      form.setFieldsValue({ kod: "", name: "" });
      return;
    }

    if (idText == null) return;

    let cancelled = false;
    setLoading(true);
    fetchSprText(vid, idText)
      .then((data) => {
        if (cancelled) return;
        const row = normalizeSprText(data);
        if (row.idText == null) {
          setError("Шаблон не найден");
          return;
        }
        form.setFieldsValue({
          kod: row.kod ?? "",
          name: row.name ?? ""
        });
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || "Не удалось загрузить");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, isNew, vid, idText, form]);

  const onFinish = async (values) => {
    if (!canEdit) return;
    setSaving(true);
    setError("");
    const body = {
      vid,
      name: values.name ?? "",
      kod: hideKod ? "" : (values.kod || "").trim()
    };
    try {
      const saved = isNew
        ? await createSprText({ ...body, idUpper: idUpper ?? 0 })
        : await saveSprText({ ...body, idText });
      message.success("Сохранено");
      onSaved?.(saved);
    } catch (e) {
      setError(e.message || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="spr-text-card__center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="spr-text-card__tab">
      {error ? (
        <Alert type="error" showIcon message={error} style={{ marginBottom: 12 }} />
      ) : null}
      <Form
        className="spr-text-card__form"
        form={form}
        {...formItemLayout}
        onFinish={onFinish}
        requiredMark={false}
        colon={false}
        disabled={!canEdit}
        layout="horizontal"
      >
        {!hideKod ? (
          <Form.Item label="Код" name="kod">
            <Input maxLength={20} autoFocus={isNew || canEdit} />
          </Form.Item>
        ) : null}
        <Form.Item label="Содержание" name="name">
          <Input.TextArea
            rows={10}
            autoSize={{ minRows: 8, maxRows: 24 }}
            autoFocus={hideKod && (isNew || canEdit)}
          />
        </Form.Item>
      </Form>
      <Space className="spr-text-card__footer">
        {canEdit ? (
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Сохранить
          </Button>
        ) : null}
        <Button onClick={onCancel}>Закрыть</Button>
      </Space>
    </div>
  );
};

export default SprTextMain;
